import React, { Fragment } from 'react';
import { Box, Text, Flex } from '@chakra-ui/react';
import { Quotes32 } from '@carbon/icons-react';

const quotes = [
  {
    quote:
      'There is no world department of education, but Times Higher Education is doing a real service to universities by developing definitions and data that can be used for comparison and understanding.',
    person: 'Lydia Snover',
    position: 'Director of institutional research',
    institution: 'Massachusetts Institute of Technology',
  },
  {
    quote:
      'Data gives us a view on how the world perceives us, and a perspective not readily available elsewhere.',
    person: 'Sunny Kwong',
    position: 'Director of planning',
    institution: 'Chinese University of Hong Kong',
  },
];

const Seperator = () => (
  <Box
    my={4}
    as="hr"
    borderWidth={1}
    borderColor="gray.300"
    borderTopStyle="solid"
    height={0}
  />
);

const HomeQuotes = () => (
  <Box>
    <Seperator />
    {quotes.map(({ quote, person, position, institution }, i) => (
      <Fragment key={quote}>
        {i > 0 && <Seperator />}
        <Flex textAlign="center" flexDirection="row">
          <Box as={Quotes32} height={50} width={50} />
          <Box flexGrow={1} maxW="90%">
            <Text mb={2} fontSize="xl">
              {quote}
            </Text>
            <Text mb={2} fontWeight="bold">
              {person}
            </Text>
            <Text mb={4} fontStyle="italic">
              {position}, {institution}
            </Text>
          </Box>
          <Box
            as={Quotes32}
            height={50}
            width={50}
            transform="rotate(180deg)"
          />
        </Flex>
      </Fragment>
    ))}
    <Seperator />
  </Box>
);

export default HomeQuotes;
